import { render, staticRenderFns } from "./TransactionCode.vue?vue&type=template&id=2c873abd&scoped=true&"
import script from "./TransactionCode.vue?vue&type=script&lang=js&"
export * from "./TransactionCode.vue?vue&type=script&lang=js&"
import style0 from "./TransactionCode.vue?vue&type=style&index=0&id=2c873abd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c873abd",
  null
  
)

export default component.exports